import { Fragment } from "react";
import hpAboutImg from "../img/hp_about_1_inner-min.jpg";
import hpAboutInner from "../img/hp_about_2_inner-min.jpg";
import promoText from "../img/promo_text-sm_en.svg";
import promoTextXs from "../img/promo_text-xs_en.svg";

const homePageData = {
    en: [
        {
            id: "123",
            img: hpAboutImg,
            title: "Find your treasure",
            description: "Raise the anchor of your imagination and set sail with us to discover the taste of eternal youth. Each of our candies conceals a different story!",
            link: "/products#tangy-jelly",
            buttonName: <Fragment>Explore candy <span>islands</span></Fragment>,
        },
        {
            id: "124",
            img: hpAboutInner,
            title: "I, Captain Candy",
            description: <Fragment>Discover a story full of adventure,<br />suspense and knowledge</Fragment>,
            link: "/captain-story",
            buttonName: <Fragment>My story</Fragment>,
        },
    ],
};

const promoTextHeader = {
    en: {
        text: "Welcome on varis board",
        promoText: promoText,
        promoTextXs: promoTextXs,
    },
};

export {
    homePageData,
    promoTextHeader,
};